export var AddressFormat;
(function (AddressFormat) {
    AddressFormat["FULL"] = "FULL";
    AddressFormat["FULL_COUNTRY"] = "FULL_COUNTRY";
    AddressFormat["CITY_AND_COUNTRY"] = "CITY_AND_COUNTRY";
})(AddressFormat || (AddressFormat = {}));
